<script>
import { defineComponent } from 'vue';
import PriceSheetItem from '@/components/customer/pricesheets/pricesheetItem.vue';

export default defineComponent({
    name: 'pricesheet',
    setup() {},
    props: {
        sheet: Object,
    },
    components: {
        PriceSheetItem
    },
    created() {

    }
    
})
</script>

<template>
    <q-expansion-item expand-icon-class="wcwBlue expandIconWCW">
            <template v-slot:header>
                <q-item-section>
                <div class="row">
                    <div class="col-12">
                        <h3 style="font-size: 1.2em;line-height: 1.5em;"># {{sheet.description}}</h3>
                        <span class="dateCreatedList">Good Through:<span>{{sheet.goodThroughDate}}</span></span>
                    </div>
                </div>
                </q-item-section>
            </template>

            <template v-slot:default>

            <div class="bodyContainer consignmentProduct q-pa-none">

                <q-list separator class="q-pa-none">

                    <span v-if="sheet.items != null && sheet.items.length>0">
                        <price-sheet-item v-for="(item, idx) in sheet.items" :key="idx" :item=item></price-sheet-item>
                    </span>


                </q-list>

                <div >

                    <q-seperator/>
                </div>
            </div>
                
            </template>
    </q-expansion-item>
    <div class="mobileDiv"></div>
</template>
